export const ANIMATION_DURATION = 1000; // 1 sec
